module.exports = __webpack_public_path__ + "img/gift_fr-BE.e4b32841.svg";